import { useEntityFollowers, useEntityFollowing } from "../../Entity/api/queries";
import { useUserFollowers, useUserFollowing } from "../../User/api/queries";
import { User, PaginatedResponse } from "../../../types/types";

interface UseNetworkDataProps {
  userId?: string;
  entityId?: string;
  network: string;
  queryString: string;
}

interface UseNetworkDataReturn {
  data: PaginatedResponse<User> | undefined;
  isLoading: boolean;
}

export const useNetworkData = ({
  userId,
  entityId,
  network,
  queryString,
}: UseNetworkDataProps): UseNetworkDataReturn => {
  const { data: entityFollowers, isLoading: isEntityFollowersLoading } = useEntityFollowers(
    entityId,
    network === "followers" ? queryString : undefined
  );

  const { data: entityFollowing, isLoading: isEntityFollowingLoading } = useEntityFollowing(
    entityId,
    network === "following" ? queryString : undefined
  );

  const { data: userFollowers, isLoading: isUserFollowersLoading } = useUserFollowers(
    userId,
    network === "followers" ? queryString : undefined
  );

  const { data: userFollowing, isLoading: isUserFollowingLoading } = useUserFollowing(
    userId,
    network === "following" ? queryString : undefined
  );

  const data = entityId
    ? network === "followers"
      ? entityFollowers
      : entityFollowing
    : network === "followers"
    ? userFollowers
    : userFollowing;

  const isLoading = entityId
    ? network === "followers"
      ? isEntityFollowersLoading
      : isEntityFollowingLoading
    : network === "followers"
    ? isUserFollowersLoading
    : isUserFollowingLoading;

  return { data, isLoading };
};
